import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = Object.assign(
    () => <span className="loading-spinner loading-spinner--medium" />,
    {
        Small: () => <span className="loading-spinner loading-spinner--small" />,
        Medium: Object.assign(
            () => <span className="loading-spinner loading-spinner--medium" />,
            {
                AbsoluteTopRight: () => (
                    <span className="loading-spinner loading-spinner--medium loading-spinner--absolute-top-right" />
                ),
                AbsoluteCenter: () => (
                    <span className="loading-spinner loading-spinner--medium loading-spinner--absolute-center" />
                ),
            },
        ),
        Big: () => <span className="loading-spinner loading-spinner--big" />,
    },
);

export default LoadingSpinner;
